import { fetchEndpointData } from '@utils/fetchEndpointData';

import type {
  CustomerPortalInvoiceListItem,
  CustomerPortalInvoiceResponse,
} from './endpoints/CustomerPortalInvoicesEndpoint.types';

export interface CustomerPortalInvoicesFilters {
  search?: string;
}

export async function fetchCustomerPortalInvoices(args: {
  customerId: number;
  cursor?: string;
  take?: number;
  filters?: CustomerPortalInvoicesFilters;
}): Promise<CustomerPortalInvoiceListItem[]> {
  const searchParams = new URLSearchParams();
  searchParams.append('customerId', args.customerId.toString());
  if (args.cursor != null) {
    searchParams.append('id', args.cursor);
  }
  if (args.take != null) {
    searchParams.append('take', args.take.toString());
  }
  if (args.filters?.search) {
    searchParams.append('search', args.filters.search);
  }

  return fetchEndpointData<CustomerPortalInvoiceListItem[]>(
    `/api/customer-portal/invoices?${searchParams.toString()}`,
    { method: 'GET' },
  );
}

export async function fetchCustomerPortalInvoice(id: string): Promise<CustomerPortalInvoiceResponse> {
  return fetchEndpointData<CustomerPortalInvoiceResponse>(`/api/customer-portal/invoices/${id}`, {
    method: 'GET',
  });
}
